// The safety net for the three calls that execute a test (the table, the list, the save-and-run): a refusal of
// the request is told to the user and, when the list is stale, reloaded; anything else goes to the global
// httpErrorsHandler as before. Local on purpose (backend plan, §6.4): the handler of main.js is not changed.
//
// What the host provides:
//   refreshAfterExecution()  optional; reloads what the host shows when the refusal says it is stale.
import { describeExecuteRejection } from '../utils/executeRejection'

export default {
  methods: {
    handleExecuteRejection(err) {
      return describeExecuteRejection(err).then((rejection) => {
        if (!rejection) {
          this.httpErrorsHandler(err)
          return
        }

        this.$bvToast.toast(this.$t(rejection.messageKey), {
          title: this.$t('efficiencyTestFailures.title'),
          variant: 'danger',
        })
        if (rejection.reload && this.refreshAfterExecution) {
          this.refreshAfterExecution()
        }
      })
    },
  },
}
